"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs3/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectWithoutProperties"));

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectSpread"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));

var _omit = _interopRequireDefault(require("lodash/omit"));

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _environment = _interopRequireDefault(require("@spothero/utils/environment"));

var _CloudinaryImagePropTypes = _interopRequireDefault(require("./CloudinaryImagePropTypes"));

var _Image = _interopRequireDefault(require("../Image/Image"));

(function () {
  var enterModule = (typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal : require('react-hot-loader')).enterModule;
  enterModule && enterModule(module);
})();

var CloudinaryImage =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(CloudinaryImage, _Component);

  function CloudinaryImage(props) {
    var _this;

    (0, _classCallCheck2.default)(this, CloudinaryImage);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(CloudinaryImage).call(this, props));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      src: null
    });
    var width = props.width,
        height = props.height,
        watermark = props.watermark,
        quality = props.quality;
    _this._transformation = [{
      width: width,
      height: height,
      quality: quality,
      crop: 'fill',
      flags: 'progressive',
      dpr: _environment.default.isHighDensityDisplay() ? 2 : 1,
      fetch_format: 'auto' // eslint-disable-line camelcase

    }];

    if (watermark) {
      _this._transformation.push((0, _objectSpread2.default)({}, watermark));
    }

    return _this;
  }

  (0, _createClass2.default)(CloudinaryImage, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props = this.props,
          cloudinary = _this$props.cloudinary,
          cloudinaryImageId = _this$props.cloudinaryImageId; // eslint-disable-next-line react/no-did-mount-set-state

      this.setState({
        src: cloudinary.url(cloudinaryImageId, {
          transformation: this._transformation
        })
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          className = _this$props2.className,
          width = _this$props2.width,
          height = _this$props2.height,
          imgAttributes = (0, _objectWithoutProperties2.default)(_this$props2, ["className", "width", "height"]);
      var src = this.state.src;
      var classes = (0, _classnames.default)('cld-hidpi', className); // the source is set after component is mounted otherwise there are mis-matching DPR attributes in the url
      // since node will always set the DPR to 1 and high density displays will have it set to 2+.

      if (!src) {
        return null;
      }

      return _react.default.createElement(_Image.default, (0, _extends2.default)({
        className: classes,
        height: height,
        width: width,
        src: src
      }, (0, _omit.default)(imgAttributes, ['cloudinary', 'cloudinaryImageId', 'watermark'])));
    }
  }, {
    key: "__reactstandin__regenerateByEval",
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }]);
  return CloudinaryImage;
}(_react.Component);

exports.default = CloudinaryImage;
(0, _defineProperty2.default)(CloudinaryImage, "propTypes", _CloudinaryImagePropTypes.default);
(0, _defineProperty2.default)(CloudinaryImage, "defaultProps", {
  width: 320,
  height: 180,
  quality: 50
});
;

(function () {
  var reactHotLoader = (typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal : require('react-hot-loader')).default;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(CloudinaryImage, "CloudinaryImage", "/Users/mprzybylski/Work/SpotHero/fe-ui/src/CloudinaryImage/CloudinaryImage.jsx");
})();

;

(function () {
  var leaveModule = (typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal : require('react-hot-loader')).leaveModule;
  leaveModule && leaveModule(module);
})();